import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        // Status chips — use these instead of inline `bg-green-500/20 text-green-700`
        // ad-hoc classes so every "success / warning / danger / info" state has
        // a single source of truth and dark-mode behaviour. See DESIGN.md.
        success:
          "border-transparent bg-brand-success/15 text-brand-success-dark dark:text-brand-success",
        warning:
          "border-transparent bg-brand-warning/15 text-brand-warning-dark dark:text-brand-warning",
        danger:
          "border-transparent bg-brand-danger/15 text-brand-danger-dark dark:text-brand-danger",
        info:
          "border-transparent bg-brand-primary/15 text-brand-primary-dark dark:text-brand-primary-light",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
